// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__304-S","header":"Messages_header__2MxQA"};